export default __webpack_public_path__ + "static/media/onePlan.821bd641.svg";